window.addEventListener('scroll', function () {
	const SCROLL_THRESHOLD = 20;
	const headerElement = document.querySelector('header.header-site');

	if (!headerElement) {
		return;
	}

	headerElement.classList.toggle('scrolled', window.scrollY > SCROLL_THRESHOLD);
});

jQuery(document).ready(function ($) {
	$('[tabindex="0"]').keydown(function (event) {
		if (event.key === 'Enter' || event.key === ' ') {
			$(this).click();
		}
	});
});

/* Skip content */
document.addEventListener('DOMContentLoaded', function () {
	const linkGoSecondSection = document.getElementById('GoSecondSection');
	const secondSection = document.querySelector('.general-section:nth-of-type(2)');

	if (!linkGoSecondSection || !secondSection) return;

	linkGoSecondSection.addEventListener('click', function (event) {
		event.preventDefault();
		secondSection.scrollIntoView({behavior: 'smooth'});
	});
});

document.fonts.ready.then(function () {
	document.body.classList.add('font-loaded');
});

jQuery(document).ready(function ($) {
	jQuery('.content-main-cpt .wp-block-button .wp-block-button__link').each(
		function () {
			jQuery(this).append('<span class="icon-arrow-ic"></span>');
		}
	);
});

/* Search header */
jQuery(document).ready(function ($) {
	$('.toggle-search').on('click', function (e) {
		e.preventDefault();
		const $container = $('.search-container.desktop-form');
		const $form = $('.search-container.desktop-form .search-form');

		$form.slideToggle(200, function () {
			$container.toggleClass('active', $form.is(':visible'));

			if ($form.is(':visible')) {
				$form.find('input[name="s"]').focus();
			}
		});
	});

	$('.search-container.desktop-form .search-icon').on('click', function (e) {
		e.preventDefault();
		$(this).closest('form').submit();
	});

	$('.mobile-form .search-icon').on('click', function (e) {
		e.preventDefault();
		$(this).closest('form').submit();
	});
});

/**
 * Start-> Video side_by_side_card
 */
jQuery(document).ready(function ($) {
	$('.js-content-video-side-by-side-card .plyr-placeholder').on(
		'click',
		function () {
			const $wrapper = $(this).closest('.plyr-video-wrapper');
			const type = $wrapper.data('type');

			$(this).hide();

			let playerElement;

			if (type === 'file') {
				const $video = $wrapper.find('video');
				$video.removeClass('is-hidden');
				playerElement = $video[0];
			} else if (type === 'embed') {
				const $iframe = $wrapper.find('iframe');
				$iframe.removeClass('is-hidden');
				playerElement = $iframe[0];
			}

			const player = new Plyr(playerElement, {
				controls: [
					'play',
					'progress',
					'current-time',
					'mute',
					'volume',
					'settings',
					'fullscreen',
				],
			});

			if (type === 'file') {
				player.play();
			}
		}
	);
});

jQuery(document).ready(function ($) {
	const $videoCards = $(
		'.js-content-video-side-by-side-card--file-and-embed'
	);

	if ($videoCards.length === 0) return;

	$videoCards.each(function () {
		const $container = $(this);
		const $video = $container.find('.video-file');
		const videoEl = $video.get(0);
		const $playIcon = $container.find('.icon-video-side-by-side-card');

		if (!videoEl) return;

		const player = new Plyr(videoEl, {
			controls: [
				'play',
				'progress',
				'current-time',
				'mute',
				'volume',
				'fullscreen',
			],
		});

		$container.removeClass('show-controls');

		$playIcon.on('click', function () {
			player.play();
		});

		videoEl.addEventListener('play', function () {
			$playIcon.hide();
			$container.addClass('show-controls');
		});

		videoEl.addEventListener('ended', function () {
			player.restart();
			player.pause();
			$container.removeClass('show-controls');
			$playIcon.show();
		});
	});
});

// Hide .navigation if the total is 1
jQuery(document).ready(function ($) {
	$('.ss-navigation').each(function () {
		const total = $(this).find('.ss-pagination-count .total').text().trim();
		if (total === '1') {
			$(this).hide();
		}
	});

	$('.swiper-pagination-fraction').each(function () {
		const total = $(this).find('.swiper-pagination-total').text().trim();
		if (total === '1') {
			$(this).hide();
		}
	});
});

// Tablepress responsive
document.addEventListener('DOMContentLoaded', function () {
	const tables = document.querySelectorAll('.tablepress');

	const tableStates = [];

	tables.forEach((table) => {
		const tbody = table.querySelector('tbody');
		if (!tbody) return;

		const originalRows = Array.from(tbody.querySelectorAll('tr')).map(
			(row) => row.cloneNode(true)
		);

		tableStates.push({
			table,
			tbody,
			originalRows,
			isTransformed: false,
		});
	});

	function transformAllTables() {
		tableStates.forEach((state) => {
			const {tbody, originalRows} = state;

			if (window.innerWidth <= 991 && !state.isTransformed) {
				const maxColumns = 5;
				const newRows = [];

				for (let i = 1; i <= maxColumns; i++) {
					const newRow = document.createElement('tr');

					originalRows.forEach((row) => {
						const col = row.querySelector(`.column-${i}`);
						if (col) newRow.appendChild(col.cloneNode(true));
					});

					newRows.push(newRow);
				}

				tbody.innerHTML = '';
				newRows.forEach((row) => tbody.appendChild(row));
				state.isTransformed = true;
			} else if (window.innerWidth > 991 && state.isTransformed) {
				tbody.innerHTML = '';
				originalRows.forEach((row) => {
					tbody.appendChild(row.cloneNode(true));
				});
				state.isTransformed = false;
			}
		});
	}

	transformAllTables();

	window.addEventListener('resize', transformAllTables);
});